import Image from 'app/Components/Shared/Image/image';
import React, {useState, useEffect, useRef, useMemo} from 'react';
import {Container, TabPane, Row, Col} from 'reactstrap';
import images from './images/images';
import CircularProgressBar from './CircularProgressbar';
import {connect} from 'react-redux';
import BtnSubmit from '../../../Shared/Buttons/BtnSubmit';
import {isMobile, isBrowser} from 'react-device-detect';
import {
  setRemovedSurfSocResult,
  setActiveLobbyTab,
  getExtendedPackageData,
  setSelectedAbroadPackage,
  abroadAddSoc,
  resetAddedExtendedPackageResult,
} from '../cellcomAbroadBlockSlice';
import { removePackage ,getCustomerAbroadUsageDisplay , getUsageData} from '../Shared/abroadThunk';
import {prepareUrl} from '../../../../utilities/StringHelpers/StringHelpers.js';
import {lobbyTabsEnum} from '../cellcomAbroadVariables';
import {useInView} from 'react-intersection-observer';
import './AbroadUsage.scss';
import PlaneLoader from '../../AbroadTicketBlock/PlaneLoader';
import {gaEvent} from '../../../../utilities/analytics/tracking';
import gaParams from '../../../../utilities/analytics/constants';
import AbroadTooltip from '../Shared/Components/Tooltip/AbroadTooltip';
import CancelSurfPopUp from './PopUps/CancelSurfPopUp';
import ExtendedPackageSurfPopUp from './PopUps/ExtendedPackageSurfPopUp';
import SuccessfulPackageInstall from './PopUps/SuccessfulPackageInstall';
import SuccessfulSurfBlockRemoved from './PopUps/SuccessfulSurfBlockRemoved';
import FailedUpdatePackage from './PopUps/FailedUpdatePackage';
import PopUp from '../../../Shared/Popup/PopUp';
import {getReportParams, report} from '../../../../middleware/report';
import {Fragment} from 'react';

function AbroadUsage({
  setRemovedSurfSocResult,
  removedSurfSocResult,
  userUsageDataCompleted,
  setActiveLobbyTab,
  userUsageData,
  context,
  packageWarning,
  removePackage,
  getExtendedPackageData,
  abroadAddSoc,
  lobbyId,
  mobile,
  otpTicketId,
  addedExtendedPackageResult,
  urlToDataUsageBlock,
  getUsageData,
  resetAddedExtendedPackageResult,
  getCustomerAbroadUsageDisplay,
  otpData,
  cellcomAbroad,
}) {
  const hasData = userUsageDataCompleted ? userUsageData?.hasData : false;
  const isAbroad = userUsageDataCompleted ? userUsageData?.isAbroad : false;
  const hasCurrentUsage = userUsageDataCompleted ? userUsageData?.hasCurrentUsage : false;
  const hasPreviousUsage = userUsageDataCompleted ? userUsageData?.hasPreviousUsage : false;
  const hasAnyUsages = hasPreviousUsage || hasCurrentUsage;
  const effPackage = userUsageDataCompleted ? userUsageData?.effectivePackagesToShow : [];
  const userType = userUsageDataCompleted ? userUsageData?.userType : '';
  const progBarBox = document.getElementById('usage-box-mid');
  const [showSurfBlock, setShowSurfBlock] = useState(false);
  const [showExtendedSurf, setShowExtendedSurf] = useState(false);
  const [displaySuccessfulPackageInstall, setDisplaySuccessfulPackageInstall] = useState(false);
  const [displayUnsuccessfulPackageInstall, setDisplayUnsuccessfulPackageInstall] = useState(false);
  const [displaySuccessfulSurfBlockRemoved, setDisplaySuccessfulSurfBlockRemoved] = useState(false);

  useEffect(() => {
    if (progBarBox) {
      progBarBox.scrollIntoView({behavior: 'smooth'});
    }
  }, []);

  useEffect(() => {
    if (addedExtendedPackageResult === false) {
      setDisplayUnsuccessfulPackageInstall(true);
    } else if (addedExtendedPackageResult === true) {
      setDisplaySuccessfulPackageInstall(true);
    }
  }, [addedExtendedPackageResult]);

  useEffect(() => {
    if (removedSurfSocResult) {
      setDisplaySuccessfulSurfBlockRemoved(true);
    }
  }, [removedSurfSocResult]);

  function closePopUp() {
    setShowSurfBlock(false);
    setShowExtendedSurf(false);
    setDisplaySuccessfulPackageInstall(false);
    setDisplayUnsuccessfulPackageInstall(false);
    setDisplaySuccessfulSurfBlockRemoved(false);
    setRemovedSurfSocResult(null);
  }

  function closeSurfPopUp() {
    setShowSurfBlock(false);
  }

  function renderWarningMsg(warningTxt, displayToolTip) {
    return (
      <div className='warningMsg-wrapper'>
        <span className={`warning-txt margin-zero`} dangerouslySetInnerHTML={{__html: warningTxt}}></span>
        {displayToolTip && (
          <AbroadTooltip tooltipId='warningToolTip' tooltipText='פרטים אודות תעריפי חריגה אפשר למצוא בחשוב לדעת באזור החבילה שלי' />
        )}
      </div>
    );
  }

  function renderUsageDisplayMode() {
    if (hasAnyUsages && hasData && effPackage && effPackage.length > 0) {
      gaEvent(
        gaParams.ABROAD_MY_ABROAD_DISPLAY_MODE_TYPE.category,
        gaParams.ABROAD_MY_ABROAD_DISPLAY_MODE_TYPE.eventType,
        userUsageData.mode
      );
      const one = 'מחבילת הגלישה שלך';
      const many = 'בחבילות הגלישה שלך';
      const underHeader = effPackage.length > 1 ? many : one;
      const usagesOnly = effPackage
        .map((p) => ({...p, usages: p.usages.filter((u) => u.ivrSubCategoryCode == 'RD')}))
        .filter((p) => p.usages.length > 0);
      const moreThenOneCircle = usagesOnly.length != 1 ? true : false;
      return (
        <>
          {isMobile ? (
            <>
              <div
                className='circles-container'
                style={moreThenOneCircle ? {justifyContent: 'flex-end', width: '260px'} : {justifyContent: 'space-evenly', width: '220px'}}>
                {usagesOnly.map((p, i) => (
                  <Fragment key={i}>
                    <CircularProgressBar
                      usage={p.usages[0].percentageUsed}
                      unit={p.usages[0].quantityUnitOfMeasure}
                      outOfTotal={p.usages[0].quantity}
                      underHeader={underHeader}></CircularProgressBar>
                  </Fragment>
                ))}
              </div>
              <div className='circle-under-header'>{underHeader}</div>
            </>
          ) : (
            <>
              <div
                className='circles-container'
                style={moreThenOneCircle ? {justifyContent: 'flex-end', width: '420px'} : {justifyContent: 'space-evenly', width: '420px'}}>
                {usagesOnly.map((p, i) => (
                  <Fragment key={i}>
                    <CircularProgressBar
                      usage={p.usages[0].percentageUsed}
                      unit={p.usages[0].quantityUnitOfMeasure}
                      outOfTotal={p.usages[0].quantity}
                      underHeader={underHeader}></CircularProgressBar>
                  </Fragment>
                ))}
              </div>
              <div className='circle-under-header'>{underHeader}</div>
            </>
          )}
        </>
      );
    }
    if (userUsageData.mode == 'Ticket') {
      gaEvent(
        gaParams.ABROAD_MY_ABROAD_DISPLAY_MODE_TYPE.category,
        gaParams.ABROAD_MY_ABROAD_DISPLAY_MODE_TYPE.eventType,
        userUsageData.mode
      );
      return <Image className='img' alt='icon' src={images.ticketPlanes} />;
    }
    if (userUsageData.mode == 'Globe') {
      gaEvent(
        gaParams.ABROAD_MY_ABROAD_DISPLAY_MODE_TYPE.category,
        gaParams.ABROAD_MY_ABROAD_DISPLAY_MODE_TYPE.eventType,
        userUsageData.mode
      );
      return <Image className='img-with-data' alt='icon' src={images.globe} />;
    }
    if (userUsageData.mode == 'CircleBar' && effPackage.length == 0) {
      gaEvent(
        gaParams.ABROAD_MY_ABROAD_DISPLAY_MODE_TYPE.category,
        gaParams.ABROAD_MY_ABROAD_DISPLAY_MODE_TYPE.eventType,
        userUsageData.mode
      );
      return <Image className='img-with-data' alt='icon' src={images.globe} />;
    }
  }

  function renderMobileHeader() {
    if ((hasAnyUsages && effPackage && effPackage.length > 0) || userUsageData.mode == 'CircleBar') return null;
    if (userUsageData.mode == 'Ticket') {
      if (isAbroad && hasAnyUsages) {
        return <div className='mobile-header'>קיימים שימושים בחו"ל</div>;
      }
      if (!hasCurrentUsage && !hasPreviousUsage) {
        return <div className='mobile-header'>לאחרונה לא השתמשת במנוי בחו"ל</div>;
      }
      return null;
    }
    if (userUsageData.mode == 'Globe') {
      return null;
    }
  }

  function renderUsageBoxHeader() {
    if ((hasAnyUsages && effPackage && effPackage.length > 0) || userUsageData.mode == 'CircleBar') return null;
    if (userUsageData.mode == 'Ticket') {
      if (isAbroad && hasAnyUsages) {
        return <div className='box-header'>קיימים שימושים בחו"ל</div>;
      }
      if (!hasCurrentUsage && !hasPreviousUsage) {
        return <div className='box-header'>לאחרונה לא השתמשת במנוי בחו"ל</div>;
      }
      return null;
    }
    if (userUsageData.mode == 'Globe') {
      return null;
    }
  }

  function reportGAWhenBuyPackage(warningObj) {
    gaEvent(
      gaParams.ABROAD_MY_ABROAD_CLICK_WARNING_BTN.category,
      gaParams.ABROAD_MY_ABROAD_CLICK_WARNING_BTN.eventType,
      warningObj.warningTxt
    );
    let reportParams = {};
    reportParams = getReportParams();
    reportParams.area = 'SelfCare';
    reportParams.subArea = 'Cellcom Abroad';
    reportParams.channel = userUsageData.userType == 'Private' ? 'WebsitePrivate' : 'WebsiteBusiness';
    reportParams.actionType = 'Redirect To Buy A Package';
    reportParams.status = 'Ongoing';
    reportParams.messageText = 'Redirect To Buy A Package';
    reportParams.param1 = 'WEBSITE';
    if (cellcomAbroad.isJETAuthentication) {
      reportParams.param1 = 'JET';
    }
    if (otpData.validatedCostumerData?.isSeparatedSale || cellcomAbroad.userUsageData?.accountSegment?.toUpperCase() === 'CANTSALENOW') {
      reportParams.param3 = 'מכר בהפרדה';
    }
    report(reportParams);
  }

  async function goToBuyAPackage(warningObj) {
    reportGAWhenBuyPackage(warningObj);

    const data = {
      blockId: lobbyId,
      userType: userType,
      phoneNumber: mobile,
    };

    switch (warningObj.warningType) {
      case 'AlmostFinishedData':
        await getExtendedPackageData(data);
        setShowExtendedSurf(!showExtendedSurf);
        break;
      case 'FinishedData':
        await getExtendedPackageData(data);
        setShowExtendedSurf(!showExtendedSurf);
        break;
      default:
        userType == 'Private' ? setActiveLobbyTab(lobbyTabsEnum.PRIVATE) : setActiveLobbyTab(lobbyTabsEnum.BUSINESSACCOUNT);
        break;
    }
  }

  function redirectToAbroadUsage() {
    gaEvent(
      gaParams.ABROAD_MY_ABROAD_CLICK_SHOW_ALL_USAGES.category,
      gaParams.ABROAD_MY_ABROAD_CLICK_SHOW_ALL_USAGES.eventType,
      gaParams.ABROAD_MY_ABROAD_CLICK_SHOW_ALL_USAGES.eventParams
    );
    context.navigateTo(urlToDataUsageBlock);
  }

  function renderWarningContainer() {
    const warningData = packageWarning?.genericInfo?.packageWarning ? packageWarning.genericInfo.packageWarning : null;
    if (warningData && warningData.showWarning === true) {
      const warningBtnTxt = warningData.buttonText;
      const warningTxt = isBrowser ? warningData.warningText : warningData.warningMobileText;
      const surfWarningTxt =
        otpData.validatedCostumerData?.isSeparatedSale || cellcomAbroad.userUsageData?.accountSegment?.toUpperCase() === 'CANTSALENOW'
          ? '<b>רגע, זה חשוב!</b> המנוי שלך חסום לגלישה בחו"ל<br />פנה לאיש קשר בארגונך בכדי לבטל את חסימת הגלישה.'
          : '<b>רגע, זה חשוב!</b> המנוי שלך חסום לגלישה בחו"ל';
      const surfBtnTxt = 'להסרת החסימה';
      const displayToolTip = warningData.showTooltip;
      gaEvent(
        gaParams.ABROAD_MY_ABROAD_DISPLAY_WARNING_TYPE.category,
        gaParams.ABROAD_MY_ABROAD_DISPLAY_WARNING_TYPE.eventType,
        warningTxt
      );
      const warningObj = {warningTxt: warningTxt, warningType: warningData.warningType};
      return (
        <>
          {warningData.warningType == 'NoWarning' ? null : (
            <div className='waning-container'>
              <Image alt='warning' src={images.warning} className='warning-img' />
              {renderWarningMsg(warningTxt, displayToolTip)}
              {warningBtnTxt && <BtnSubmit text={warningBtnTxt} onclick={() => goToBuyAPackage(warningObj)} />}
            </div>
          )}
          {warningData && warningData.surfWarning ? (
            <div className='waning-container'>
              <Image alt='warning' src={images.warning} className='warning-img' />
              {renderWarningMsg(surfWarningTxt)}
              {otpData.validatedCostumerData?.isSeparatedSale ||
              cellcomAbroad.userUsageData?.accountSegment?.toUpperCase() === 'CANTSALENOW' ? null : (
                <BtnSubmit text={surfBtnTxt} onclick={() => setShowSurfBlock(true)} />
              )}
            </div>
          ) : null}
        </>
      );
    }
    return null;
  }

  function renderByDevice() {
    if (isBrowser) {
      if (userUsageData === 'Pending' || !userUsageData) {
        return (
          <div className='row abroad-usage-container'>
            <PlaneLoader />
          </div>
        );
      } else if (userUsageData == 'error') {
        return null;
      }
      return (
        <div className='row abroad-usage-container'>
          <div className='header'>
            פעילות המנוי <span className='bold'>בחו"ל </span>
          </div>
          {hasAnyUsages && (
            <div className='sub-header' onClick={() => redirectToAbroadUsage()}>
              {' '}
              {'< לפירוט הפעילות של המנוי בחו"ל'}
            </div>
          )}
          <div className='usage-box' id='usage-box-mid'>
            {userUsageDataCompleted && renderUsageDisplayMode()}
            {renderUsageBoxHeader()}
            {renderWarningContainer()}
          </div>
        </div>
      );
    }
    if (userUsageData === 'Pending' || !userUsageData) {
      return <PlaneLoader />;
    }
    return (
      <div className='unify-both-containers'>
        <div className='row abroad-usage-container'>
          <div className='header'>
            פעילות המנוי <span className='bold'>בחו"ל </span>
          </div>
          {renderMobileHeader()}
          {hasAnyUsages && (
            <div className='sub-header' onClick={() => redirectToAbroadUsage()}>
              {' '}
              {'<לפירוט הפעילות של המנוי בחו"ל'}
            </div>
          )}
          <div className='usage-box'>{renderUsageDisplayMode()}</div>
        </div>
        {renderWarningContainer()}
      </div>
    );
  }

  return (
    <>
      <PopUp showPopUp={showSurfBlock} onClose={closeSurfPopUp}>
        {showSurfBlock && (
          <CancelSurfPopUp
            onClose={closeSurfPopUp}
            removePackage={removePackage}
            otpPhone={mobile}
            otpTicketId={otpTicketId}
            getUsageData={getUsageData}
            getCustomerAbroadUsageDisplay={getCustomerAbroadUsageDisplay}
          />
        )}
      </PopUp>
      <PopUp showPopUp={showExtendedSurf} onClose={closePopUp}>
        <ExtendedPackageSurfPopUp onClose={closePopUp} abroadAddSoc={abroadAddSoc} mobile={mobile} otpTicketId={otpTicketId} />
      </PopUp>
      <PopUp showPopUp={displayUnsuccessfulPackageInstall} onClose={closePopUp}>
        <FailedUpdatePackage onClose={closePopUp} resetAddedExtendedPackageResult={resetAddedExtendedPackageResult} />
      </PopUp>
      <PopUp showPopUp={displaySuccessfulPackageInstall} onClose={closePopUp}>
        <SuccessfulPackageInstall onClose={closePopUp} resetAddedExtendedPackageResult={resetAddedExtendedPackageResult} />
      </PopUp>
      <PopUp showPopUp={displaySuccessfulSurfBlockRemoved} onClose={closePopUp}>
        <SuccessfulSurfBlockRemoved onClose={closePopUp} removedSurfSocResult={removedSurfSocResult} />
      </PopUp>
      {renderByDevice()}
    </>
  );
}

const mapStateToProps = (state) => ({
  userUsageData: state.cellcomAbroad.userUsageData,
  packageWarning: state.cellcomAbroad.subscriberAbroadUsageData,
  userUsageDataCompleted: state.cellcomAbroad.userUsageDataCompleted,
  lobbyId: state.cellcomAbroad.epiStyleInitializationData.lobbyBlockId,
  mobile: state.cellcomAbroad.otpData.otpPhone || state.authentication.loginData.userDetails.contactNumber,
  addedExtendedPackageResult: state.cellcomAbroad.addedExtendedPackageResult,
  urlToDataUsageBlock: state.cellcomAbroad.epiStyleInitializationData.urlToDataUsageBlock,
  removedSurfSocResult: state.cellcomAbroad.removedSurfSocResult,
  otpData: state.cellcomAbroad.otpData,
  cellcomAbroad: state.cellcomAbroad,
});

const mapDispatchToProps = {
  setActiveLobbyTab,
  removePackage,
  getExtendedPackageData,
  setSelectedAbroadPackage,
  abroadAddSoc,
  getUsageData,
  resetAddedExtendedPackageResult,
  getCustomerAbroadUsageDisplay,
  setRemovedSurfSocResult,
};

export default connect(mapStateToProps, mapDispatchToProps)(AbroadUsage);
